import { Loader2 } from "lucide-react";

export default function Spinner({ className = "" }) {
  return <Loader2 className={`animate-spin ${className || "w-4 h-4"}`} aria-hidden="true" />;
}
